import { IconProps } from '../';
const OpenHamburgerIcon = ({
  color = 'var(--color-sage-500)',
  customClasses,
  ...rest
}: IconProps) => {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 58 58"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path d="M12 24H46.2232" stroke={color} strokeWidth="2" />
      <path d="M12 35H46.2232" stroke={color} strokeWidth="2" />
    </svg>
  );
};

export default OpenHamburgerIcon;
